const prefix = "shopping/cart";

export const FETCH_CART = `${prefix}/FETCH_CART`;
// export const FETCH_CART_START = `${prefix}/FETCH_CART_START`;
// export const FETCH_CART_FAIL = `${prefix}/FETCH_CART_FAIL`;
// export const FETCH_CART_SUCCESS = `${prefix}/FETCH_CART_SUCCESS`;

export const ADD_CART_POSITION = `${prefix}/ADD_CART_POSITION`;
export const DELETE_CART_POSITION = `${prefix}/DELETE_CART_POSITION`;
// export const ADD_CART_POSITION_START = `${prefix}/ADD_CART_POSITION_START`;
// export const ADD_CART_POSITION_SUCCESS = `${prefix}/ADD_CART_POSITION_SUCCESS`;
// export const ADD_CART_POSITION_FAIL = `${prefix}/ADD_CART_POSITION_FAIL`;

export const PATCH_CART_POSITION = `${prefix}/PATCH_CART_POSITION`;

export const CART_SYNC_START = `${prefix}/CART_SYNC_START`;
export const CART_SYNC_SUCCESS = `${prefix}/CART_SYNC_SUCCESS`;
export const CART_SYNC_FAIL = `${prefix}/CART_SYNC_FAIL`;

export const fetchCart = () => ({ type: FETCH_CART });
export const addCartPosition = (position) => ({ type: ADD_CART_POSITION, payload: position, meta: { thunk: true } });
export const deleteCartPosition = (positionId) => ({ type: DELETE_CART_POSITION, payload: positionId, meta: { thunk: true } });

export const patchCartPosition = (position) => ({
  type: PATCH_CART_POSITION,
  payload: position,
  meta: { thunk: true },
});
